export enum ExternalLinksEnum {
  NDI = 'https://www.gndi.com.br/empresas',
}
